export default function Band() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.424"
      height="37.421"
      viewBox="0 0 37.424 37.421"
    >
      <g id="electric-guitar" transform="translate(0.002 -0.5)">
        <path
          id="Path_2174"
          data-name="Path 2174"
          d="M35.78.644c-1.022-.355-2.61-.133-4,1.558L27.133,7.833l-.5.5a.731.731,0,0,0,1.035,1.033l.006-.006,1.06,1.062L14.889,24.292l-1.06-1.062,2.754-2.759.005-.005,7.472-7.485a.731.731,0,1,0-1.035-1.033L16.414,18.57a5.189,5.189,0,0,1,.306-2.516q.046-.161.093-.33a2.143,2.143,0,0,0-1.4-2.607,2.083,2.083,0,0,0-2.648,1.293l0,.011C11.488,17.611,10.5,19.6,7.522,20.29a10.132,10.132,0,0,0-5.983,3.583A7.826,7.826,0,0,0,.021,29.158a10.6,10.6,0,0,0,3.4,6.481A8.553,8.553,0,0,0,9.245,37.92a7.873,7.873,0,0,0,1.346-.114A6.442,6.442,0,0,0,15.4,34.3a.731.731,0,1,0-1.309-.651,5.013,5.013,0,0,1-3.748,2.721,7.041,7.041,0,0,1-5.907-1.78,9.156,9.156,0,0,1-2.955-5.539c-.212-2.78,1.352-6.167,6.374-7.334,3.65-.848,4.9-3.33,6.267-6.744.231-.545.572-.558.818-.473a.69.69,0,0,1,.467.834l-.091.324a5.986,5.986,0,0,0-.092,4.109l-2.944,2.949a.732.732,0,0,0,0,1.033l2.093,2.1a.731.731,0,0,0,1.034,0l2.849-2.854a3.549,3.549,0,0,0,3.569.3.419.419,0,0,1,.431.019.532.532,0,0,1,.133.5,1.468,1.468,0,0,1-1.084.972c-3.391,1.156-4.223,1.641-5.33,4.145a.731.731,0,1,0,1.337.591c.873-1.974,1.249-2.256,4.465-3.353a2.858,2.858,0,0,0,2.048-2.086,1.981,1.981,0,0,0-.628-1.89,1.845,1.845,0,0,0-1.882-.27,2.15,2.15,0,0,1-1.992,0L30.2,11.022c.306-.153.581-.29.831-.413,2.586-1.281,2.726-1.42,3.745-3.722.1-.234.219-.494.349-.783a2.25,2.25,0,0,1,.771-.752,3.043,3.043,0,0,0,1.52-2.276.729.729,0,0,0,0-.075A2.462,2.462,0,0,0,35.78.644Zm-.743,3.528A3.436,3.436,0,0,0,33.8,5.5c-.132.293-.249.556-.354.793A6.108,6.108,0,0,1,32.457,8.1,8.83,8.83,0,0,1,30.385,9.3l-.471.234L28.661,8.278,32.9,3.132c.918-1.113,1.864-1.292,2.395-1.107a1,1,0,0,1,.66.967c-.056.524-.359.768-.923,1.18Zm0,0"
          transform="translate(0 0)"
          fill="#2c2750"
        />
        <path
          id="Path_2175"
          data-name="Path 2175"
          d="M333.415,134.87a.73.73,0,0,0,.517-.214l.014-.014a.731.731,0,0,0-1.034-1.034l-.014.014a.731.731,0,0,0,.517,1.248Zm0,0"
          transform="translate(-308.369 -123.18)"
          fill="#2c2750"
        />
        <path
          id="Path_2176"
          data-name="Path 2176"
          d="M125.753,347.254a.731.731,0,0,0,.517-1.247l-2.093-2.1a.731.731,0,0,0-1.035,1.033l2.093,2.1a.729.729,0,0,0,.517.214Zm0,0"
          transform="translate(-113.945 -318.11)"
          fill="#2c2750"
        />
        <path
          id="Path_2177"
          data-name="Path 2177"
          d="M92.77,374.338a.731.731,0,0,0,0,1.034l2.093,2.1a.731.731,0,1,0,1.034-1.033l-2.093-2.1A.731.731,0,0,0,92.77,374.338Zm0,0"
          transform="translate(-85.792 -346.315)"
          fill="#2c2750"
        />
        <path
          id="Path_2178"
          data-name="Path 2178"
          d="M208.462,411.208a.731.731,0,1,1-.731-.731A.731.731,0,0,1,208.462,411.208Zm0,0"
          transform="translate(-191.871 -380.011)"
          fill="#2c2750"
        />
      </g>
    </svg>
  );
}
